import { CampaignSearchDataHeaderCell } from '../components/CampaignSearchDataHeaderCell';

type Props = {
  disableFiltering?: boolean;
  title: string;
  columnProps?: any;
  arrangedId: string;
  searchFieldName?: string;
  filterFieldName?: string;
  isParsedByValue?: boolean;
};

export const useCampaignSearchDataColumn = (props: Props) => {
  const { columnProps, ...rest } = props;

  return {
    ...columnProps,
    dataIndex: props.arrangedId,
    title: <CampaignSearchDataHeaderCell {...rest} />,
  };
};
